/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignRequestCarbonCopy } from './SignRequestCarbonCopy';
import {
    SignRequestCarbonCopyFromJSON,
    SignRequestCarbonCopyFromJSONTyped,
    SignRequestCarbonCopyToJSON,
} from './SignRequestCarbonCopy';
import type { SignRequestSigner } from './SignRequestSigner';
import {
    SignRequestSignerFromJSON,
    SignRequestSignerFromJSONTyped,
    SignRequestSignerToJSON,
} from './SignRequestSigner';

/**
 * 
 * @export
 * @interface SignRequestRecipients
 */
export interface SignRequestRecipients {
    /**
     * A list of signer recipients included in the sign request. Each signer represents a person required to review or sign the document
     * @type {Array<SignRequestSigner>}
     * @memberof SignRequestRecipients
     */
    signers?: Array<SignRequestSigner>;
    /**
     * A list of carbon copy recipients included in the sign request. These recipients receive a copy of the document but are not required to sign
     * @type {Array<SignRequestCarbonCopy>}
     * @memberof SignRequestRecipients
     */
    carbonCopies?: Array<SignRequestCarbonCopy>;
}

/**
 * Check if a given object implements the SignRequestRecipients interface.
 */
export function instanceOfSignRequestRecipients(value: object): boolean {
    return true;
}

export function SignRequestRecipientsFromJSON(json: any): SignRequestRecipients {
    return SignRequestRecipientsFromJSONTyped(json, false);
}

export function SignRequestRecipientsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestRecipients {
    if (json == null) {
        return json;
    }
    return {
        
        'signers': json['signers'] == null ? undefined : ((json['signers'] as Array<any>).map(SignRequestSignerFromJSON)),
        'carbonCopies': json['carbonCopies'] == null ? undefined : ((json['carbonCopies'] as Array<any>).map(SignRequestCarbonCopyFromJSON)),
    };
}

export function SignRequestRecipientsToJSON(value?: SignRequestRecipients | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'signers': value['signers'] == null ? undefined : ((value['signers'] as Array<any>).map(SignRequestSignerToJSON)),
        'carbonCopies': value['carbonCopies'] == null ? undefined : ((value['carbonCopies'] as Array<any>).map(SignRequestCarbonCopyToJSON)),
    };
}

